export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14')
];

export const server_loads = [2,3];

export const dictionary = {
		"/(app)": [~4,[2]],
		"/(app)/assistant": [5,[2]],
		"/(app)/docs": [~6,[2,3]],
		"/(app)/docs/search": [~8,[2,3]],
		"/(app)/docs/tags": [~9,[2,3]],
		"/(app)/docs/tags/[tag]": [~10,[2,3]],
		"/(app)/docs/[...slug]": [~7,[2,3]],
		"/login": [~14],
		"/(app)/schedule": [~11,[2]],
		"/(app)/schedule/[id]": [~12,[2]],
		"/(app)/users": [~13,[2]]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);